import { render, staticRenderFns } from "./ChbSection.vue?vue&type=template&id=076b9349"
import script from "./ChbSection.vue?vue&type=script&lang=js"
export * from "./ChbSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports